<div class="pane flat" *ngIf="!(alertsLoading$ | async); else loading">
  <div class="alerts">
    <div class="alerts-header">
      <h5>
        <fa-icon [icon]="['fas', 'bell']"></fa-icon>
        {{ "alerts-center.title.alerts-center" | translate }}
      </h5>

      <sui-toolbar
        *ngIf="
          userFacade.hasPermissionSync(
            AppFeatures.ADVANCED_MASS_OPERATIONS_ROOT
          )
        "
      >
        <app-search-input
          [placeholder]="'feed-actions.placeholder.search' | translate"
          [value]="searchQuery"
          (inputChanged)="handleSearchStringAlertChange($event)"
        ></app-search-input>
      </sui-toolbar>
    </div>

    <div class="alerts-holder">
      <ng-container *ngIf="alerts?.length > 0; else noAlerts">
        <app-alert-card
          *ngFor="let alert of alerts; trackBy: trackByAlertId"
          [alert]="alert"
          [searchQuery]="searchQuery"
          (alertEdit)="editAlert($event)"
          (alertDelete)="deleteAlert($event)"
        ></app-alert-card>
      </ng-container>
    </div>
  </div>

  <ng-template #noAlerts>
    <p class="no-alerts">
      {{ "alerts-center.message.no-alerts" | translate }}
    </p>
  </ng-template>
</div>

<ng-template #loading>
  <app-loading></app-loading>
</ng-template>
